/**
 * Orchestra AI Platform - Workflow Builder Wrapper
 * 
 * Wrapper component for the Workflow Builder that works with tab-based navigation
 */

import { WorkflowBuilder } from '../WorkflowBuilder/WorkflowBuilder';
import PropTypes from 'prop-types';

/**
 * Orchestra Workflow Builder Component
 * @param {Object} props
 * @param {Object} props.currentUser - Current user object
 * @param {Function} props.onBack - Back navigation handler
 * @param {Function} props.onTabChange - Tab change handler
 * @param {string} [props.workflowId] - Workflow ID to load
 */
export function OrchestraWorkflowBuilder({ currentUser, onBack, onTabChange, workflowId }) {
  return (
    <div style={{ 
      padding: '20px', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      boxSizing: 'border-box'
    }}>
      <div style={{ 
        marginBottom: '20px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        flexShrink: 0
      }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
          🔧 Orchestra AI Platform - 視覺化工作流程建構器
        </h1>
        <button
          onClick={onBack}
          style={{
            padding: '8px 16px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          ← 返回
        </button>
      </div>

      <div style={{ 
        flex: 1, 
        overflow: 'hidden',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column'
      }}>
        <WorkflowBuilder
          workflowId={workflowId || undefined}
          readOnly={false}
        />
      </div>
    </div>
  );
}

OrchestraWorkflowBuilder.propTypes = {
  currentUser: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onTabChange: PropTypes.func.isRequired,
  workflowId: PropTypes.string,
};

